export const FolderIcon = () => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24">
      <path
        d="M9.8409 3.59998H3.35985C2.78859 3.6019 2.24146 3.82408 1.8385 4.21775C1.43555 4.61141 1.20969 5.14441 1.21049 5.6998L1.2 18.3002C1.20158 18.8566 1.42964 19.3898 1.83435 19.7833C2.23906 20.1768 2.7875 20.3984 3.35985 20.4H20.6401C21.2125 20.3984 21.7609 20.1768 22.1657 19.7833C22.5703 19.3898 22.7984 18.8566 22.8 18.3002V7.79961C22.7984 7.24318 22.5703 6.70997 22.1657 6.31651C21.7609 5.92306 21.2125 5.70133 20.6401 5.6998H16.3205H12.0008L9.8409 3.59998Z"
        fill="#0056B8"
      />
    </svg>
  );
};
